import { render, staticRenderFns } from "./BloqueiosAba.vue?vue&type=template&id=0c5ca1be&scoped=true"
import script from "./BloqueiosAba.vue?vue&type=script&lang=js"
export * from "./BloqueiosAba.vue?vue&type=script&lang=js"
import style0 from "./cashback.css?vue&type=style&index=0&id=0c5ca1be&prod&scoped=true&lang=css&external"
import style1 from "./BloqueiosAba.vue?vue&type=style&index=1&id=0c5ca1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ca1be",
  null
  
)

export default component.exports